module.exports = __webpack_public_path__ + "img/labelsOrderOn.2fcb3380.svg";